import type { LessonSlots } from '../../model/lessons/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonSlotsApiOptions {
  disciplineId: string | number
}

/** The booking slots come only with the discipline's lessons list (`booking_slots`): read its smallest page and
 *  keep the slots. They are the start hours from the current hour on, in the admin view timezone. */
export const useLessonSlotsApi = async (options: LessonSlotsApiOptions): Promise<LessonSlots | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.index', { discipline_id: options.disciplineId, per_page: 1 })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)
    const slots: LessonSlots | undefined = data.data?.booking_slots

    return slots ?? null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))

    return null
  }
}
